import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import ApiServices from "../../../Services/ApiServices/ApiServices";

const ServicesAdd = ({ onSuccess = () => {}, onCancel = () => {} }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, message: "", severity: "error" });

  const closeSnack = () => setSnack((s) => ({ ...s, open: false }));

  const validate = () => {
    if (!name.trim()) {
      setSnack({ open: true, message: "Name is required", severity: "error" });
      return false;
    }
    if (!price || isNaN(price)) {
      setSnack({ open: true, message: "Valid price is required", severity: "error" });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e && e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    try {
      const payload = {
        name: name.trim(),
        description: description.trim(),
        price: price.toString(),
        is_active: isActive === true || isActive === "true" ? true : false,
      };
      const res = await ApiServices.post("service-offerings/", payload);
      const data = res?.data ?? res;
      onSuccess("Service added successfully");
      // optionally return data
      return data;
    } catch (err) {
      console.error(err);
      let msg = "Failed to add service.";
      if (err?.response?.data) {
        // try to extract first error
        const d = err.response.data;
        if (typeof d === "string") msg = d;
        else if (d?.detail) msg = d.detail;
        else {
          // aggregate field errors
          msg = Object.values(d).flat().join(" ") || msg;
        }
      } else if (err?.message) msg = err.message;
      setSnack({ open: true, message: msg, severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
      <TextField label="Name" value={name} onChange={(e) => setName(e.target.value)} required fullWidth />
      <TextField
        label="Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        multiline
        rows={3}
        fullWidth
      />
      <TextField
        label="Price"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
        required
        type="number"
        inputProps={{ step: "0.01", min: 0 }}
        fullWidth
      />
      <FormControlLabel
        control={<Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />}
        label="Active"
      />

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", pt: 1 }}>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" disabled={loading} sx={{ backgroundColor: "#094c9f" }}>
          {loading ? <CircularProgress size={20} /> : "Add"}
        </Button>
      </Box>

      <Snackbar open={snack.open} autoHideDuration={4200} onClose={closeSnack}>
        <Alert onClose={closeSnack} severity={snack.severity} sx={{ width: "100%" }}>
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ServicesAdd;
